import { initializeApp } from 'firebase/app';
import {
  connectAuthEmulator,
  getAuth,
  onAuthStateChanged,
  signOut,
  signInWithEmailAndPassword,
  signInWithCustomToken,
  User,
} from 'firebase/auth';
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore';
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions';
import { connectStorageEmulator, getStorage } from 'firebase/storage';
import { getFirebaseConfig } from './firebaseConfig';

// Local end-to-end testing against the Firebase emulators (never prod data):
// REACT_APP_USE_EMULATORS=true npm start
const useEmulators = process.env.REACT_APP_USE_EMULATORS === 'true';

// 1. Initialize Firebase app
export const app = initializeApp(
  useEmulators
    ? { ...getFirebaseConfig(), projectId: 'demo-motion-hub', storageBucket: 'demo-motion-hub.appspot.com' }
    : getFirebaseConfig(),
);

// 2. Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'us-central1');

if (useEmulators) {
  connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
  connectFirestoreEmulator(db, '127.0.0.1', 8080);
  connectStorageEmulator(storage, '127.0.0.1', 9199);
  connectFunctionsEmulator(functions, '127.0.0.1', 5001);
  // Lets test scripts sign in with an emulator custom token.
  (window as any).__e2e = { signInWithCustomToken: (token: string) => signInWithCustomToken(auth, token) };
}

// 3. Auth helpers
export async function signInUser(email: string, password: string) {
  if (!email || !password) return;
  return signInWithEmailAndPassword(auth, email, password);
}

export function userStateListener(callback: (user: User | null) => void) {
  return onAuthStateChanged(auth, callback);
}

export async function SignOutUser(): Promise<void> {
  await signOut(auth);
}
